const t = "56px", i = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  height: t
}, Symbol.toStringTag, { value: "Module" })), o = {
  width: "375px",
  marginRight: "41px",
  marginTop: "24px",
  bottom: "114px"
}, n = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  chatHead: i,
  chatWindow: o
}, Symbol.toStringTag, { value: "Module" })), a = (e) => ({
  display: "box",
  display: "-moz-box",
  display: "-ms-box",
  display: "-webkit-box",
  WebkitLineClamp: e,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis"
}), l = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  limitTextDisplay: a
}, Symbol.toStringTag, { value: "Module" })), { chatHead: p, chatWindow: r } = n, { limitTextDisplay: c } = l, s = {
  alignment: {
    flexCenter: {
      display: "flex",
      justifyContent: "center",
      alignContent: "center",
      alignItems: "center"
    }
  },
  cssVarPrefix: "chat",
  custom: {
    chatHead: p,
    chatWindow: r
  },
  mixins: {
    limitTextDisplay: c
  },
  palette: {
    primary: {
      10: "#D3EAF8"
    },
    text: {
      onlight01: "rgba(0, 0, 0, 0.88)"
    },
    warning: {
      highlight: "#fef4e5"
    },
    grey: {
      40: "#A4A4A3",
      30: "#BABABA",
      25: "#eeeeee",
      20: "#D2D1D1"
    }
  },
  shadows: [
    "none",
    "0px 4px 16px 0px rgba(26, 26, 26, 0.45)"
  ],
  shape: {
    borderRadius: "10px"
  },
  typography: {
    caption1: {
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "130%"
    },
    caption2: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
      textAlign: "center"
    },
    caption4: {
      fontSize: "11px",
      fontWeight: 400,
      lineHeight: "12px"
    }
  }
};
export {
  s as default
};
//# sourceMappingURL=index.es.js.map
